import { observer } from "mobx-react";

import { Popup } from "components/Popup/Popup";
import Button from "components/UI/Button/Button";
import { TextInput } from "components/UI/TextInput/TextInput";

import apiKeysStore, {
  API_KEY_MODAL,
  MAX_NAME_LENGTH,
} from "../ApiKeysStore";

import "./ApiKeyModal.scss";

/**
 * Модалка выпуска ключа.
 *
 * Два состояния в одном окне: до выпуска — имя, после — ключ целиком. Второй
 * раз сервер его не отдаст: в базе лежит только хеш, поэтому окно и говорит об
 * этом прямо, а не мелким шрифтом.
 *
 * Живёт внутри страницы, а не в App.jsx: она нужна только здесь, а Popup и так
 * рисуется в DOM постоянно.
 */
export const ApiKeyModal = observer(() => {
  const { issuedKey, name, creating, copied } = apiKeysStore;

  return (
    <Popup
      modalType={API_KEY_MODAL}
      title={issuedKey ? "Ключ выпущен" : "Новый ключ"}
      onClick={() => apiKeysStore.closeCreateModal()}
    >
      {issuedKey ? (
        <div className="apikeymodal">
          <p className="apikeymodal__warning">
            Скопируйте ключ сейчас. Он показывается один раз — второй раз его не
            покажем, потому что не храним.
          </p>
          <p className="apikeymodal__key">{issuedKey}</p>
          <div className="apikeymodal__buttons">
            <Button
              title={copied ? "Скопировано" : "Скопировать"}
              classes={["small"]}
              onClick={() => apiKeysStore.copyIssuedKey()}
            />
            <Button
              title="Закрыть"
              classes={["outlined", "small"]}
              onClick={() => apiKeysStore.closeCreateModal()}
            />
          </div>
        </div>
      ) : (
        <div className="apikeymodal">
          <p className="apikeymodal__hint">
            Назовите ключ так, чтобы через полгода было понятно, какая
            интеграция перестанет работать, если его отозвать.
          </p>
          <TextInput
            className="apikeymodal__input"
            placeholder="Например, интеграция с CRM"
            maxLength={MAX_NAME_LENGTH}
            value={name}
            onChange={(e) => apiKeysStore.setName(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") apiKeysStore.create();
            }}
          />
          <div className="apikeymodal__buttons">
            <Button
              title={creating ? "Выпускаем…" : "Выпустить"}
              classes={["small"]}
              disabled={!name.trim() || creating}
              onClick={() => apiKeysStore.create()}
            />
          </div>
        </div>
      )}
    </Popup>
  );
});
